export class TypedEventBus<Events extends Record<string, any>> {
  private target = document;

  emit<K extends keyof Events>(eventType: K, detail: Events[K]): void {
    const event = new CustomEvent(String(eventType), {
      detail,
      bubbles: true,
      cancelable: true,
    });
    this.target.dispatchEvent(event);
  }

  on<K extends keyof Events>(eventType: K, handler: (event: CustomEvent<Events[K]>) => void): void {
    this.target.addEventListener(String(eventType), handler as EventListener);
  }

  off<K extends keyof Events>(
    eventType: K,
    handler: (event: CustomEvent<Events[K]>) => void,
  ): void {
    this.target.removeEventListener(String(eventType), handler as EventListener);
  }
}
